import React from 'react'
import clsx from 'clsx'
import styles from '../dropdown.module.scss'
import PropTypes from 'prop-types'

const DropdownRow = ({ children, className, component, ...rest }) => {
  const Component = component || 'div'
  return (
    <Component {...rest} className={clsx(styles['row'], className)}>
      {children}
    </Component>
  )
}

DropdownRow.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}

export default DropdownRow
